import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// import { appDB } from '../powersync/app.db'
import Dashboard from '../containers/dashboard'
import { UserContext } from '../contexts/user.context'
import SystemUsersManagement from '../containers/system-users-management'

const Users = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userSession } = useContext(UserContext)
  const [displayElements, setDisplayElements] = useState<boolean>(false)

  useEffect(() => {
    // const unsubscribe = appDB.watch("SELECT * FROM systemusers WHERE belongsTo = 'holdings' AND deleted = false AND role <> 'super-admin'", [], {
    //   onResult: (result: any) => {
    //     const rows = result.rows?._array ?? []
    //     console.log('📥 Noti callback systemusers:', rows)
    //     // setPayments(rows)
    //   },
    //   onError: (err: unknown) => console.error('Error en watch():', err)
    // }) as (() => void) | undefined
    // return () => {
    //   if (typeof unsubscribe === 'function') {
    //     unsubscribe()
    //   }
    // }
  }, [])

  useEffect(() => {
    // const fetchLocalSystemUsers = async () => {
    //   try {
    //     const rows = await appDB.database.getAll('SELECT * FROM systemusers LIMIT 1')
    //     const numberOfRows = await appDB.database.getAll('SELECT COUNT(*) FROM systemusers')
    //     console.log('numberOfRows', (numberOfRows as Array<any>)[0]['COUNT(*)'])
    //     console.log('📥 Datos PowerSync SystemUsers (SQLite local):', rows)
    //   } catch (err) {
    //     console.error('❌ Error al consultar la base local de PowerSync', err)
    //   }
    // }
    // fetchLocalSystemUsers()
  }, [])

  useEffect(() => {
    if (!userSession) {
      return
    }

    if (userSession && userSession?.role.indexOf('admin') > -1 && userSession?.role.indexOf('builder') > -1) {
      navigate('/404')
    } else {
      setDisplayElements(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, userSession])

  return <Dashboard>{displayElements ? <SystemUsersManagement /> : <></>}</Dashboard>
}

export default Users
